const defaultYear = 2023;
export default defaultYear;
